import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { numberWithCommas } from "../../dashboard/common";

const total_requests = {
  Chart: "LEX_PLATFORM_USAGE",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const unfulfilled_requests = {
  Chart: "MISSED_UTTERANCES_LEX_SUMMARY",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const session_duration = {
  Chart: "AVERAGE_SESSION_TIME_DURATION_BETWEEN_REQUEST_AND_RESPONSE",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const styles = {
  grid: {
    height: "100%"
  },
  root: {
    maxWidth: "150px",
    height: "100%"
  },
  element: {
    display: "flex",
    height: "50%",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center"
  },
  h1: {
    fontSize: "60px"
  }
};

class UsageSummaryClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, draggable, totalRequests, unfulfilledRequests, sessionDuration } = this.props;

    return (
      <div>
        <div className="widgetTitle">Usage Summary</div>
        {/*<div className="widgetTitleDescription">Number of sessions by user - click for details</div>*/}
        <div className="widgetBody">
          <Grid container justify="center" spacing={2} className={classes.grid}>
            <Grid item key={0}>
              <div className={classes.root}>
                <div className={classes.element}>
                  {totalRequests ? (
                    draggable ? (
                      <Typography variant="h1" classes={{ h1: classes.h1 }}>
                        0
                      </Typography>
                    ) : (
                      <Typography variant="h1" classes={{ h1: classes.h1 }}>
                        {totalRequests.data}
                      </Typography>
                    )
                  ) : (
                    <Typography variant="h1" classes={{ h1: classes.h1 }}>
                      -
                    </Typography>
                  )}
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h6">TOTAL REQUESTS</Typography>
                </div>
              </div>
            </Grid>
            <Grid item key={1}>
              <div className={classes.root}>
                <div className={classes.element}>
                  {unfulfilledRequests ? (
                    draggable ? (
                      <Typography variant="h1" classes={{ h1: classes.h1 }}>
                        0
                      </Typography>
                    ) : (
                      <Typography variant="h1" classes={{ h1: classes.h1 }}>
                        {unfulfilledRequests.data}
                      </Typography>
                    )
                  ) : (
                    <Typography variant="h1" classes={{ h1: classes.h1 }}>
                      -
                    </Typography>
                  )}
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h6">UNFULFILLED REQUESTS</Typography>
                </div>
              </div>
            </Grid>
            <Grid item key={2}>
              <div className={classes.root}>
                <div className={classes.element}>
                  {draggable ? (
                    <Typography variant="h1" classes={{ h1: classes.h1 }}>
                      0
                    </Typography>
                  ) : (
                    <Typography variant="h1" classes={{ h1: classes.h1 }}>
                      {sessionDuration.data}
                    </Typography>
                  )}
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h6">AVERAGE SESSION DURATION</Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const previewStyles = {
  grid: {
    height: "100%"
  },
  root: {
    maxWidth: "150px",
    height: "100%"
  },
  element: {
    display: "flex",
    height: "50%",
    width: "50px",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden"
  },
  h1: {
    fontSize: "20px"
  },
  h3: {
    fontSize: "7px"
  }
};

class UsageSummaryPreview extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className="widgetTitle">Usage Summary</div>
        <div className="widgetBody">
          <Grid container justify="center" spacing={2} className={classes.grid}>
            <Grid item key={0}>
              <div className={classes.root}>
                <div className={classes.element}>
                  <Typography variant="h1" classes={{ h1: classes.h1 }}>
                    123
                  </Typography>
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h3" classes={{ h3: classes.h3 }}>
                    TOTAL REQUESTS
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item key={1}>
              <div className={classes.root}>
                <div className={classes.element}>
                  <Typography variant="h1" classes={{ h1: classes.h1 }}>
                    12
                  </Typography>
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h3" classes={{ h3: classes.h3 }}>
                    UNFULFILLED REQUESTS
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item key={2}>
              <div className={classes.root}>
                <div className={classes.element}>
                  <Typography variant="h1" classes={{ h1: classes.h1 }}>
                    2:07
                  </Typography>
                </div>
                <Divider />
                <div className={classes.element}>
                  <Typography variant="h3" classes={{ h3: classes.h3 }}>
                    AVERAGE SESSION DURATION
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export const UsageSummaryPreviewStyled = withStyles(previewStyles)(UsageSummaryPreview);

function mapStateToProps(state, ownProps) {
  return {
    totalRequests: state.dashboard.data["TotalRequests"],
    unfulfilledRequests: state.dashboard.data["MissedUtterances"],
    sessionDuration: { labels: [], data: "-" },
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const UsageSummaryContent = connect(
  mapStateToProps,
  undefined
)(withStyles(styles)(UsageSummaryClass));
